


























































import Moment from "moment";
import { Component, Mixins } from "vue-property-decorator";
import { UserDetailMixin } from "./mixins";
import { FixedLoading } from "../../system";

@Component({
  components: {
    FixedLoading,
  }
})
export default class UserDetailViewer extends Mixins(UserDetailMixin) {
  get rows(): number {
    return this.edittingComment.split("\n").length + 2;
  }

  toDateFormat(date: string): string {
    try {
      return Moment(date).format("YYYY/MM/DD");
    } catch {
      return "";
    }
  }
}
